var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ENV_LIT_NETWORK, getUrls } from '@shared/utils/config/environment';
import { deepConvertBigInt } from '@shared/utils/off-chain/deep-convert-bigint';
import { ChainId } from '@shared/utils/config/networks';
import { executeDirectTransactionsSolana, } from '@shared/utils/solana/base/executeDirectTransactionsSolana';
import { createDBTransferReceipt } from '@/lib/db/DBTransferHistoryHelpers';
import { createTDBOrder } from '@/lib/db/DBOrderHelpers';
import { createDBOrderHistory } from '@/lib/db/DBOrderHistoryHelpers';
export default function executeViaClientSolana(_a) {
    return __awaiter(this, arguments, Promise, function (_b) {
        var tokenPrices, toAssetPriceData, dbOrderType, result, dbOrder, _c, startTime, executionResponse, txns, executionResponseError, e_1, decodedResponse, executionTime, dbOrderHistory, token_address, token_amount, token_amount_formatted, usd_value, to_address, decimals, name, symbol, from_address, network, wParams, executorUrl, updateUrl, e_2;
        var _d, _e, _f;
        var params = _b.params, pkp = _b.pkp, orderType = _b.orderType, dbOrderParams = _b.dbOrderParams, keypair = _b.keypair, existingdbOrder = _b.existingdbOrder, skipSimulation = _b.skipSimulation, transferParams = _b.transferParams;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 12, , 13]);
                    tokenPrices = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.tokenPrices;
                    toAssetPriceData = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.toAssetPriceData;
                    dbOrderType = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.dbOrderType;
                    result = {
                        message: "".concat(orderType, " client execution called"),
                    };
                    if (!existingdbOrder) return [3 /*break*/, 1];
                    _c = existingdbOrder;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, createTDBOrder({
                        cloud_wallet_address: pkp === null || pkp === void 0 ? void 0 : pkp.additionalEthAddress,
                        order: params,
                        pkp: pkp,
                        token_prices: tokenPrices,
                        order_type: dbOrderType,
                        pkp_eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
                    })];
                case 2:
                    _c = (_g.sent()).data;
                    _g.label = 3;
                case 3:
                    dbOrder = _c;
                    console.log('Executing order SOLANA dbOrder=>', dbOrder);
                    startTime = new Date().getTime();
                    executionResponse = void 0;
                    txns = (((_d = params === null || params === void 0 ? void 0 : params.transactions) === null || _d === void 0 ? void 0 : _d.swap) ||
                        ((_e = params === null || params === void 0 ? void 0 : params.transactions) === null || _e === void 0 ? void 0 : _e.transfer));
                    if (!skipSimulation) {
                        // Needs to be implemented
                    }
                    executionResponseError = null;
                    _g.label = 4;
                case 4:
                    _g.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, executeDirectTransactionsSolana({
                            transactions: txns.filter(function (x) { return x; }),
                            keypair: keypair,
                        })];
                case 5:
                    executionResponse = _g.sent();
                    if (executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.error) {
                        throw new Error("Error executing transaction: ".concat(executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.error));
                    }
                    return [3 /*break*/, 7];
                case 6:
                    e_1 = _g.sent();
                    executionResponseError = e_1 === null || e_1 === void 0 ? void 0 : e_1.message;
                    return [3 /*break*/, 7];
                case 7:
                    console.log('Executing order SOLANA client side', executionResponse, executionResponseError);
                    decodedResponse = {
                        type: orderType,
                        status: executionResponseError ? 'error' : 'success',
                        error: executionResponseError === null || executionResponseError === void 0 ? void 0 : executionResponseError.error,
                        note: 'Client side execution',
                        quoteId: params === null || params === void 0 ? void 0 : params.quoteId,
                        quote: params,
                        transferTransaction: (orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW'))
                            ? {
                                network: ChainId.SOLANA,
                                hash: executionResponse.txHash,
                                status: 'success',
                            }
                            : null,
                        swapTransactions: (txns === null || txns === void 0 ? void 0 : txns.length) > 1 && !(orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW'))
                            ? [
                                [
                                    {
                                        hash: executionResponse.txHash,
                                        network: ChainId.SOLANA,
                                        status: executionResponseError ? 'error' : 'success',
                                        explorerUrl: executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.explorerUrl,
                                        bundleId: executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.bundleId,
                                    },
                                    {
                                        hash: executionResponse.txHash1,
                                        network: ChainId.SOLANA,
                                        status: executionResponseError ? 'error' : 'success',
                                        explorerUrl: executionResponse.explorerUrl1,
                                        bundleId: executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.bundleId,
                                    },
                                ],
                            ]
                            : null,
                        solanaSwapTransaction: (txns === null || txns === void 0 ? void 0 : txns.length) == 1 && !(orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW'))
                            ? {
                                hash: executionResponse.txHash,
                                network: ChainId.SOLANA,
                                status: executionResponseError ? 'error' : 'success',
                                explorerUrl: executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.explorerUrl,
                                bundleId: executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse.bundleId,
                            }
                            : null,
                    };
                    console.log("Executing order SOLANA ".concat(orderType, " client side"), executionResponse, 'decodedResponse', decodedResponse);
                    executionTime = new Date().getTime() - startTime;
                    result['decodedResponse'] = decodedResponse;
                    result['executionTime'] = executionTime;
                    result['status'] = decodedResponse.status;
                    dbOrderHistory = void 0;
                    if (!(orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW'))) return [3 /*break*/, 9];
                    token_address = transferParams.token_address, token_amount = transferParams.token_amount, token_amount_formatted = transferParams.token_amount_formatted, usd_value = transferParams.usd_value, to_address = transferParams.to_address, decimals = transferParams.decimals, name = transferParams.name, symbol = transferParams.symbol, from_address = transferParams.from_address, network = transferParams.network;
                    wParams = {
                        from_address: from_address,
                        to_address: to_address,
                        decimals: decimals,
                        token_address: token_address,
                        token_amount: token_amount,
                        token_amount_formatted: token_amount_formatted,
                        usd_value: usd_value,
                        type: 'withdraw',
                        chain_id: isNaN(network) ? 0 : network,
                        txn: executionResponse.txHash,
                        token_metadata: JSON.stringify(deepConvertBigInt({
                            symbol: symbol,
                            name: name,
                        })),
                        result: JSON.stringify(deepConvertBigInt({
                            decodedResponse: decodedResponse,
                            executionTime: executionTime,
                        })),
                    };
                    return [4 /*yield*/, createDBTransferReceipt(wParams)];
                case 8:
                    dbOrderHistory = (_g.sent()).data;
                    return [3 /*break*/, 11];
                case 9: return [4 /*yield*/, createDBOrderHistory(deepConvertBigInt({
                        order_id: dbOrder.id,
                        cloud_wallet_address: pkp === null || pkp === void 0 ? void 0 : pkp.additionalEthAddress,
                        status: decodedResponse.error ? 'error' : 'success',
                        result: result,
                        token_prices: tokenPrices,
                        orchestrator_pkp: params === null || params === void 0 ? void 0 : params.orchestrator,
                        token_out_prices: toAssetPriceData,
                        execution_time: executionTime,
                        pkp_eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress,
                    }))];
                case 10:
                    dbOrderHistory = (_g.sent()).data;
                    _g.label = 11;
                case 11:
                    console.log('Executing order SOLANA dbOrderHistory=>', dbOrderHistory);
                    if (decodedResponse.status == 'success' && !(orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW'))) {
                        try {
                            executorUrl = ((_f = getUrls()) === null || _f === void 0 ? void 0 : _f.EXECUTOR_URL) || 'https://staging-api.tradegenius.com';
                            console.log('Executing order SOLANA executorUrl', executorUrl);
                            updateUrl = "/api/forwardGet?target=".concat(executorUrl, "/api/order/update-user-order?order_id=").concat(dbOrder.id, "&cloud_wallet=").concat(pkp === null || pkp === void 0 ? void 0 : pkp.additionalEthAddress);
                            console.log('Executing order SOLANA updateUrl=>', updateUrl);
                            fetch(updateUrl);
                        }
                        catch (e) {
                            console.log('Executing order SOLANA calling update url failed', e);
                        }
                    }
                    console.log('Executing order SOLANA client side final', result, executionTime);
                    return [2 /*return*/, {
                            result: result,
                            dbOrderHistory: dbOrderHistory,
                            dbOrder: dbOrder,
                            time: executionTime,
                            litNetwork: ENV_LIT_NETWORK,
                        }];
                case 12:
                    e_2 = _g.sent();
                    console.error('[executeViaClientSolana]', e_2);
                    throw e_2;
                case 13: return [2 /*return*/];
            }
        });
    });
}
